import { makeStyles } from '@material-ui/core/styles';


export default makeStyles((theme) => ({
    box: {
        marginTop: '150px',
    },
    title: {
        fontFamily: 'Montserrat, cursive, Arial '
    },
    container: {
        display: 'flex',
        height: '100vh',
        flexDirection: 'column',
        justifyContent: 'flex-start',

    },
    footer: {
        marginTop: 'auto'
    }
}));
